import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/Layout.css';

const Layout = ({ children }) => {
  const { usuario, logout, esContratista, esCapataz, esAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuAbierto, setMenuAbierto] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Menú para administrador
  const menuAdmin = [
    { path: '/admin-dashboard', label: 'Panel Admin', icon: '⚙️' },
    { path: '/admin-usuarios', label: 'Usuarios', icon: '👥' },
    { path: '/admin-configuracion', label: 'Configuración', icon: '🔧' },
  ];

  // Menú para contratista
  const menuContratista = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/clientes', label: 'Clientes', icon: '👥' },
    { path: '/cotizaciones', label: 'Cotizaciones', icon: '📋' },
    { path: '/proyectos', label: 'Proyectos', icon: '🏗️' },
    { path: '/trabajadores', label: 'Trabajadores', icon: '👷' },
    { path: '/especialidades', label: 'Especialidades', icon: '🔧' },
    { path: '/capataces', label: 'Capataces', icon: '👨‍💼' },
    { path: '/inventario', label: 'Inventario', icon: '📦' },
    { path: '/reportes', label: 'Reportes', icon: '📈' },
  ];

  // Menú para capataz
  const menuCapataz = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/proyectos', label: 'Mis Proyectos', icon: '🏗️' },
    { path: '/perfil', label: 'Mi Perfil', icon: '👤' },
  ];

  // Seleccionar menú según el tipo de usuario
  const menuItems = esAdmin ? menuAdmin : (esContratista ? menuContratista : menuCapataz);

  return (
    <div className="layout">
      <aside className={`sidebar ${menuAbierto ? 'abierto' : ''}`}>
        <div className="sidebar-header">
          <h2>AppContra</h2>
          <button
            className="menu-toggle mobile-only"
            onClick={() => setMenuAbierto(false)}
          >
            ✕
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? 'active' : ''}
              onClick={() => setMenuAbierto(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {usuario?.nombre?.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <p className="user-name">{usuario?.nombre}</p>
              <p className="user-type">
                {esAdmin ? 'Administrador' : (esContratista ? 'Contratista' : 'Capataz')}
              </p>
            </div>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </div>
      </aside>

      <main className="main-content">
        <button
          className="menu-toggle mobile-only"
          onClick={() => setMenuAbierto(true)}
        >
          ☰
        </button>
        {children}
      </main>
    </div>
  );
};

export default Layout;
